import { request } from './client';
import type { WheelSpinsFilters, WheelSpinsPage } from './types';

export const WHEEL_SPINS_PAGE_SIZE = 50;

// Admin only: middleware answers 403 for an agent key. Empty filters are not sent.
export const fetchWheelSpins = (
  key: string,
  filters: WheelSpinsFilters,
  cursor: string | null,
  signal?: AbortSignal,
) => {
  const params = new URLSearchParams();
  Object.entries({ ...filters, cursor: cursor ?? '', limit: String(WHEEL_SPINS_PAGE_SIZE) }).forEach(
    ([name, value]) => {
      if (value) params.set(name, String(value).trim());
    },
  );
  return request<WheelSpinsPage>(`/api/daily-wheel/admin/spins?${params.toString()}`, { key, signal });
};
